import * as pageAPI from '../api/pages'
import * as types from "../mutation-types"

// initial state
const pages = {
    namespace: 'pages',

    state: {
        all: [],
        contents: [],
    },

    getters: {
        pages: (state) => state.all,
        pageContents: (state) => state.contents
    },

    mutations: {
        [types.FETCH_PAGES] (state, payload) {
            state.all      = payload.pages
            state.contents = payload.page_contents
        },

        [types.CREATE_PAGE] (state, newPage) {
            state.all.push(newPage)
        },

        [types.SORT_PAGE] (state, changedPages) {
            let targetPage = state.all.find(page => {
                return page.id === changedPages.target.id
            })

            state.all[state.all.indexOf(targetPage)]['display_order'] = changedPages.target.display_order

            if (changedPages.affected) {
                let affectedPage = state.all.find(page => {
                    return page.id === changedPages.affected.id
                })

                state.all[state.all.indexOf(affectedPage)]['display_order'] = changedPages.affected.display_order
            }
        },

        [types.UPDATE_PAGE] (state, newPage) {
            let updatePage = state.all.find(page => {
                return page.id === newPage.id
            })

            let index = state.all.indexOf(updatePage);

            state.all.splice(index, 1, newPage)
        },

        [types.REMOVE_PAGE_IMAGE] (state, imageId) {
            let pages = state.all.filter(page => page.image_id === imageId);
            for (let pageIndex in pages) {
                let newPage     = Object.assign({}, pages[pageIndex], {image_id: null})
                let updateIndex = state.all.indexOf(pages[pageIndex]);

                state.all.splice(updateIndex, 1, newPage)
            }
        },

        [types.DELETE_PAGE] (state, newPage) {
            let deletePage = state.all.find(page => {
                return page.id === newPage.id
            })

            let index = state.all.indexOf(deletePage);

            state.all.splice(index, 1)

            // delete contents
            let contents = state.contents.filter(content => {
                return content.page_id === newPage.id
            })

            for (let x in contents) {
                if (state.contents[x]) {
                    state.contents.splice(x, 1)
                }
            }
        },

        [types.CREATE_PAGE_CONTENT] (state, newPageContent) {
            state.contents.push(newPageContent)
        },

        [types.UPDATE_PAGE_CONTENT] (state, newPageContent) {
            let updatePageContent = state.contents.find(content => {
                return content.id === newPageContent.id
            })

            let index = state.contents.indexOf(updatePageContent);

            state.contents.splice(index, 1, newPageContent)
        },

        [types.SORT_PAGE_CONTENT] (state, changedContents) {
            for(let x = 0; x < changedContents.displaced.length; x++) {
                let displacedContent = changedContents.displaced[x];
                let target = state.contents.find(content => content.id === displacedContent.id);
                state.contents[state.contents.indexOf(target)]['sort'] = displacedContent.sort;
            }
        },

        [types.DELETE_PAGE_CONTENT] (state, deletedContentId) {
            let deletePageContent = state.contents.find(content => {
                return content.id === deletedContentId
            })

            let index = state.contents.indexOf(deletePageContent);

            state.contents.splice(index, 1)
        },
    },

    actions: {
        [types.FETCH_PAGES]: ({commit, dispatch, state}) => {
            return new Promise((resolve, reject) => {
                pageAPI.fetchPages(commit)
                    .then(data => {
                        commit(types.FETCH_PAGES, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },

        [types.CREATE_PAGE]: ({commit, dispatch, state}, page) => {
            return new Promise((resolve, reject) => {
                pageAPI.createPage(commit, page.fields)
                    .then(data => {
                        commit(types.CREATE_PAGE, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },

        [types.SORT_PAGE]: ({commit, dispatch, state}, pageSort) => {
            return new Promise((resolve, reject) => {
                pageAPI.sortPage(commit, pageSort)
                    .then(data => {
                        commit(types.SORT_PAGE, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },

        [types.UPDATE_PAGE]: ({commit, dispatch, state}, page) => {
            return new Promise((resolve, reject) => {
                pageAPI.updatePage(commit, page.fields)
                    .then(data => {
                        commit(types.UPDATE_PAGE, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },

        [types.DELETE_PAGE]: ({commit, dispatch, state}, page) => {
            return new Promise((resolve, reject) => {
                pageAPI.deletePage(commit, page)
                    .then(data => {
                        commit(types.DELETE_PAGE, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },

        [types.CREATE_PAGE_CONTENT]: ({commit, dispatch, state}, pageContent) => {
            return new Promise((resolve, reject) => {
                pageAPI.createPageContent(commit, pageContent)
                    .then(data => {
                        commit(types.CREATE_PAGE_CONTENT, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },

        [types.UPDATE_PAGE_CONTENT]: ({commit, dispatch, state}, pageContent) => {
            return new Promise((resolve, reject) => {
                pageAPI.updatePageContent(commit, pageContent)
                    .then(data => {
                        commit(types.UPDATE_PAGE_CONTENT, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },

        [types.SORT_PAGE_CONTENT]: ({commit, dispatch, state}, pageContent) => {
            return new Promise((resolve, reject) => {
                pageAPI.sortPageContent(commit, pageContent)
                    .then(data => {
                        commit(types.SORT_PAGE_CONTENT, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },

        [types.DELETE_PAGE_CONTENT]: ({commit, dispatch, state}, pageContent) => {
            return new Promise((resolve, reject) => {
                pageAPI.deletePageContent(commit, pageContent)
                    .then(data => {
                        commit(types.DELETE_PAGE_CONTENT, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
    },
};

export default pages;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/pages/index.js
// module id = 618
// module chunks = 0